
import React, { Component } from 'react';

class FontDisplay extends Component {
    render(){
  return ( 
        <div className="dgrComponent">
            <h1 >
                H1 style headings 
            </h1>
            <h2 >
                 H2 style text 
            </h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <hr/>
            <h1>Heading 1</h1>
            <h2>Heading 2</h2>
            <h3>Heading 3</h3>
            <h4>Heading 4</h4>
        </div>
  )};
    
};

export default FontDisplay;




// WEBPACK FOOTER //
// ./src/components/DGR/FontDisplay/FontDisplay.js